import { render } from "./AccountsPayable.vue?vue&type=template&id=9b60a218"
import script from "./AccountsPayable.vue?vue&type=script&lang=js"
export * from "./AccountsPayable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__